export enum ProfileTypes {
  OVERVIEW = 'OVERVIEW',
  SECTOR = 'SECTOR',
  INDUSTRY = 'INDUSTRY',
}
